import { apiGet, apiPost } from './client';
import type {
  AcademicSubject,
  AcademicSubjectTree,
  TopicDetail,
  SubjectProgress,
  AcademicSearchResults,
  ProgressStatus,
} from '../types';

// REAL backend calls to the Phase 2 /api/academic routes.

export function fetchAcademicSubjects(paper?: 'I' | 'II'): Promise<AcademicSubject[]> {
  const qs = paper ? `?paper=${paper}` : '';
  return apiGet<AcademicSubject[]>(`/academic/subjects${qs}`);
}

export function fetchSubjectTree(slug: string): Promise<AcademicSubjectTree> {
  return apiGet<AcademicSubjectTree>(`/academic/subjects/${slug}/tree`);
}

export function fetchTopic(id: number | string): Promise<TopicDetail> {
  return apiGet<TopicDetail>(`/academic/topics/${id}`);
}

export function fetchSubjectProgress(slug: string): Promise<SubjectProgress> {
  return apiGet<SubjectProgress>(`/academic/progress/subjects/${slug}`);
}

export function setTopicProgress(
  topicId: number,
  status: ProgressStatus,
): Promise<{ topicId: number; status: ProgressStatus }> {
  return apiPost(`/academic/progress/topics/${topicId}`, { status });
}

export function searchAcademic(q: string): Promise<AcademicSearchResults> {
  return apiGet<AcademicSearchResults>(`/academic/search?q=${encodeURIComponent(q)}`);
}

// Paper II subject selection (Module 2.2).
export function fetchMySubject(): Promise<{
  selectedSubjectSlug: string | null;
  subject: AcademicSubject | null;
}> {
  return apiGet('/academic/me/subject');
}

export function setMySubject(
  slug: string,
  confirmReset?: boolean,
  selectedSlugs?: string[]
): Promise<{ selectedSubjectSlug: string; changed: boolean }> {
  return apiPost('/academic/me/subject', { slug, confirmReset, selectedSlugs });
}

export function sanitizeSubjectSlug(slug: string): string {
  if (!slug) return slug;
  const s = String(slug).trim().toLowerCase();
  if (s === 'general-test-501' || s === 'general-test' || s === '501' || s === 'gat-501' || s === 'gat') {
    return 'paper-1';
  }
  return slug;
}
